import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";

import { APP_CONFIG } from "@application/config";
import { IContract, selectContractFields } from "@contract/data-access";

@Injectable({ providedIn: "root" })
export class ProfileContractService {
  private readonly http = inject(HttpClient);
  private readonly odataContractUrl = inject(APP_CONFIG).apiUrl.odata_contract;

  public getContractsByPerson(personId: string): Observable<IContract[]> {
    const params = new HttpParams()
      .set("$filter", `PersonId eq ${personId}`)
      .set("$select", selectContractFields);

    return this.http
      .get<{ value: IContract[] }>(`${this.odataContractUrl}/Contracts`, {
        withCredentials: true,
        params,
      })
      .pipe(map((response) => response?.value ?? []));
  }
}
